import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';

import { ICustomTheme } from 'interfaces';

type Theme = {
  theme?: ICustomTheme;
};

export const Container = styled.div(() => ({
  flex: '1 0 auto',
}));

export const Description = styled(Typography)<Theme>(({ theme }) => ({
  color: theme.colors.grey.dark,
  fontSize: theme.typography.h4.fontSize,
  marginBottom: theme.spacing(2),
  textAlign: 'center',
  '&.bold': {
    fontSize: theme.typography.h2.fontSize,
    fontWeight: theme.typography.fontWeightBold,
  },
}));

export const Title = styled(Typography)<Theme>(({ theme }) => ({
  color: theme.colors.paletteFromBO.main,
  fontSize: theme.typography.h1.fontSize,
  fontWeight: theme.typography.fontWeightBold,
  marginBottom: theme.spacing(2),
  textAlign: 'center',
}));
